<template>
  <v-menu
    bottom
    left>
    <template v-slot:activator="{ on }">
      <v-btn
        color="gray"
        icon
        v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list subheader>
      <v-subheader class="font-black">{{$t("dropdownTitle")}}</v-subheader>
      <v-divider />
      <slot />
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Dropdown extends Vue {
}
</script>